module.exports = __webpack_public_path__ + "static/media/sharing-overview-video.288a7d57.mp4";